// NOTE - Use only to cache Priority APIs

interface ICacheProps {
    [key: string]: { expiry: number; response: T };
}

const cacheList: ICacheProps[] = [];

const MemoizeAPIWithTTL = <T>(APIFunction: (...args: any[]) => Promise<T>, ttl: number) => {
    const cache: ICacheProps = {};

    cacheList.push(cache);

    return (...args: any[]) => {
        let hash = "";
        let i = args.length;

        let currentArg = null;

        while (i--) {
            currentArg = args[i];

            hash += currentArg === Object(currentArg) ? JSON.stringify(currentArg) : currentArg;
        }

        if (hash === "") {
            hash = APIFunction.name;
        }

        if (hash in cache) {
            const { expiry, response } = cache[hash];

            if (expiry > new Date().getTime()) {
                return Promise.resolve(response);
            }
        }

        return APIFunction(...args).then(response => {
            const expiry = new Date().getTime() + ttl;
            const data = {
                expiry,
                response,
            };

            cache[hash] = data;

            return response;
        });
    };
};

export default MemoizeAPIWithTTL;

const clearAll = () => {
    for (let i = 0; i < cacheList.length; i++) {
        Object.keys(cacheList[i]).forEach(value => {
            cacheList[i][value].expiry = new Date().getTime() - 1;
            cacheList[i][value].response = null;
        });
    }

    return cacheList;
};

export { clearAll };
